import React from 'react';
import { Container } from 'react-bootstrap';

import withNavigationGroupProps from '../components/withNavigationGroupProps';
import EditGroupAccessUsers from '../components/EditGroupAccessUsers';
import EditGroupSummary from '../components/EditGroupSummary';

function EditGroupAccessUsersPage(props) {
  return (
    <Container fluid>
      <EditGroupSummary {...props} />
      <EditGroupAccessUsers {...props} />
    </Container>
  );
}

export default withNavigationGroupProps(EditGroupAccessUsersPage);
